<template>
    <v-app id="login-layout" dark>
        <v-content>
            <slot />
        </v-content>
    </v-app>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import SecurityModule from "@/store/modules/SecurityModule";

    @Component
    export default class LoginLayout extends Vue{
        created(){
            SecurityModule.setToken(null);
            SecurityModule.setUser(null);
        }
    }
</script>

<style lang="scss">
    #login-layout{
        background-color: #1A1029 !important;
        background-image: url(/img/bg-2.jpg) !important;
    }
</style>
